import { render, staticRenderFns } from "./ButtonPreOrder.vue?vue&type=template&id=312dde08&scoped=true&"
import script from "./ButtonPreOrder.vue?vue&type=script&lang=js&"
export * from "./ButtonPreOrder.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPreOrder.vue?vue&type=style&index=0&id=312dde08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312dde08",
  null
  
)

export default component.exports